<template>
        <el-dialog
            :visible.sync="dialogVisible"
            :lock-scroll="false"
            :append-to-body="true"
            :close-on-click-modal="false"
            :width="dialogWidth+'px'"
            :before-close="handleClose"
            custom-class="my-el-dialog-content"
        >
                <div>
                    <div class="my-el-dialog-content-title">
                        <div>
                            <slot name="mytitle"></slot>
                        </div>
                        <i @click="handleClose" class="el-icon-close" style="font-size: 20px;color: white;"></i>
                    </div>
                    <div class="my-el-dialog-content-body">
                            <slot name="mybody"></slot>
                    </div>
                    <div class="my-el-dialog-content-footer">
                        <slot name="myfooter"></slot>
                    </div>
                </div>
                <slot name="myloading"></slot>
        </el-dialog>
</template>

<script>
export default {
    props: {
        dialogWidth: {
            type: Number,
            default: 1354,
        },
        closeCallBack: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            dialogVisible: false,
        };
    },
    methods: {
        show() {
            this.dialogVisible = true;
        },
        handleClose() {
            this.closeCallBack();
            this.dialogVisible = false;
        },
    },
};
</script>

<style scoped lang="less">
// .my-el-dialog {
/deep/ .my-el-dialog-content {
    background: transparent;
    background-color: #01082b;
    border: 1px solid #2a70e9;
    box-shadow: 0px 0px 15px 0 rgb(67 167 253 / 80%) inset;
    border-radius: 6px;
    top: 50%;
    transform: translateY(-50%);
    margin-top: 0 !important;
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
        background: radial-gradient(132.47% 82.44% at 50% 141.83%, #0048a9 0%, rgba(0, 72, 171, 0) 100%),
            linear-gradient(332deg, rgba(28, 172, 232, 0) 61.97%, rgba(12, 116, 205, 0.07) 102.92%), rgba(0, 36, 84, 0.7);
        border-radius: 8px;
        .my-el-dialog-content-title {
            height: 32px;
            padding: 0px 10px;
            border-bottom: 1px solid #2a70e9;
            font-size: 14px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color:white;
            i {
                cursor: pointer;
            }
        }
        .my-el-dialog-content-body {
            padding: 16px;
            .ivu-form-item{
                margin-bottom: 18px;
            }
            .ivu-input-group-append{
                background-color: #000;
            }
        }
        .my-el-dialog-content-footer {
            padding: 12px 18px 12px 18px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
        }
    }
}
// <!-- } -->
</style>
<style lang="less">
.ag-cell-inline-editing{
    padding: 0 !important;
    height: 40px !important;
    input{
        height: 100% !important;
    }
}
</style>